import React from "react";
import LegalNotice from "./LegalNotice";

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        maxWidth: "820px",
        margin: "0 auto",
        padding: "32px 18px 60px",
        color: "#0f172a",
        lineHeight: 1.65,
      }}
    >
      <h1 style={{ fontSize: "28px", fontWeight: 900, marginBottom: "12px" }}>
        Privacy Policy
      </h1>

      <p style={{ color: "#475569", fontSize: "14px" }}>
        Last updated: {new Date().toLocaleDateString()}
      </p>

      <section>
        <h2>Overview</h2>
        <p>
          Gildarc respects your privacy. This Privacy Policy explains what
          information we collect, how it is used, and the choices you have when
          using our educational platform.
        </p>
      </section>

      <section>
        <h2>Information We Collect</h2>
        <p>
          We collect limited, non-identifying information to support educational
          experiences. This may include:
        </p>
        <ul>
          <li>Age ranges or brackets (not full dates of birth)</li>
          <li>Filing status selections</li>
          <li>General income ranges (not exact dollar amounts unless stated)</li>
          <li>Household indicators (e.g., children, student status)</li>
          <li>Basic usage analytics (page views, interaction counts)</li>
        </ul>
      </section>

      <section>
        <h2>Information We Do Not Collect</h2>
        <p>We do <strong>not</strong> require or request:</p>
        <ul>
          <li>Social Security Numbers</li>
          <li>Full dates of birth</li>
          <li>Government ID numbers</li>
          <li>Exact home addresses</li>
          <li>Bank account or payment information</li>
        </ul>
      </section>

      <section>
        <h2>How Information Is Used</h2>
        <p>
          Information entered into Gildarc is used solely to:
        </p>
        <ul>
          <li>Display educational explanations of tax rules and benefits</li>
          <li>Show possible eligibility signals based on general inputs</li>
          <li>Improve educational content and platform usability</li>
        </ul>
        <p>
          Gildarc does not provide tax advice, prepare tax returns, or submit
          information to the IRS.
        </p>
      </section>

      <section>
        <h2>Data Storage and Retention</h2>
        <p>
          We aim to minimize data retention. Information may be stored
          temporarily to support session functionality or improve the platform.
          Where stored, data is retained only as long as necessary and may be
          anonymized or deleted.
        </p>
      </section>

      <section>
        <h2>Sharing of Information</h2>
        <p>
          We do not sell personal information. Limited data may be shared with
          trusted service providers (such as hosting or analytics providers)
          solely to operate and improve the platform.
        </p>
      </section>

      <section>
        <h2>Your Choices</h2>
        <p>
          You may choose not to provide certain inputs. Doing so may limit the
          educational features available, but will not restrict general access
          to the site.
        </p>
      </section>

      <section>
        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Updates will be
          reflected on this page with a revised “Last updated” date.
        </p>
      </section>

      <section>
        <h2>Contact</h2>
        <p>
          For questions about this Privacy Policy, please refer to the contact
          information provided in our Terms of Use.
        </p>
      </section>

      {/* Reuse your generic legal notice */}
      <LegalNotice variant="footer" align="center" />
    </div>
  );
}
